import React, { useMemo} from 'react';
import styles from './Presentations.module.scss';
import { LessonType, LastVisitedLessonContentFragment, SllLesson, SllModule } from '@api/graphql-codegen';
import LessonSection from '@src/components/lesson-details/lesson-section/LessonSection';

type Props = {
  contents: SllModule[] | undefined;
  lesson: SllLesson | undefined;
  lessonType: LessonType | undefined;
  lessonOpened: boolean;
  lastVisitedLesson?: LastVisitedLessonContentFragment;
  closeNav?: () => void;
};

function Presentations(props: Props) {
  const { contents = [], lesson, lessonOpened, lastVisitedLesson, closeNav } = props;

  const wrapperClassName = useMemo(() => {
    const classes = [styles.wrapper];
    if (lessonOpened) {
      classes.push(styles.opened);
    }

    return classes.join(' ');
  }, [lessonOpened]);
  
  return (
    <div className={wrapperClassName}>
      <div className={styles.content}>
        <LessonSection title={lesson?.name || ""} lesson={lesson as SllLesson} contents={contents} lastVisitedLesson={lastVisitedLesson} closeNav={closeNav} />
      </div>
    </div>
  );
}

export default React.memo(Presentations);
